import React from 'react';
import { Typography } from '@pinwheel/origami';
export function TextListItems(_a) {
    var textList = _a.textList;
    var textListItems = textList
        ? textList.map(function (item) { return (React.createElement(Typography, { key: item, color: "light", as: "li", align: "left", variant: "caption", weight: "normal" }, item)); })
        : null;
    return React.createElement(React.Fragment, null,
        " ",
        textListItems,
        " ");
}
export default TextListItems;
